import { useQueries, useQueryClient } from "@tanstack/react-query";

import { getBeefFootprintByYear, getBeefFootprintByYearAdmin } from "services";

import { getActiveToken, getEnvironment, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_BEEF } from "consts";

export const useGetFootprintingBeefFootprints = (farmId?: string, years: number[] = [], { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  const { user } = useUserContext();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getActiveToken();

  const isLoggedIn = isAdmin ? !!token : !!user && !!token;

  return useQueries({
    queries: years.map((year) => ({
      queryKey: [FOOTPRINTING_BEEF, farmId, year, isAdmin],
      queryFn: () => (isAdmin ? getBeefFootprintByYearAdmin(farmId ?? "", year) : getBeefFootprintByYear(farmId ?? "", year)),
      enabled:
        enabled &&
        carbonProgram?.platformFeatures?.footprinting?.enabled &&
        carbonProgram.platformFeatures.footprinting.beef === true &&
        !!farmId &&
        isLoggedIn,
      queryClient,
      gcTime: 60000,
    })),
  });
};
